export default __webpack_public_path__ + "static/breadcrumbs-bg-aead09dfeb2feab4bfcb4b524bd0b9a5.webp";